import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const metaApesExclusiveCampaignWin15000Shib10000000Giveaway: Story = {
  id: 'meta-apes-exclusive-campaign-win-15000-shib-10000000-giveaway',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Meta apes exclusive campaign win 15000 shib 10000000 giveaway',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Campaign: Earn 15,000 $SHIB in the Meta Apes Campaign',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn 15,000 $SHIB by completing the Meta Apes Campaign plus get a chance to win from a 10,000,000 $SHIB giveaway prize pool',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square, Meta Apes Campaign, SHIB, Web3 App Store, Decentralized Apps, Crypto Rewards, Meta Apes, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: '697c246f0b54e0ee36bbcb3decd17d55bfe4',
      scode: 'MagicSquare',
      ccode: 'Z1j5pxmtfz',
    },
  },
};
